// src/const/jobs.ts

import { JobOption } from '../types';
export const JOBS: JobOption[] = [
    {
        employer: 'Biblioplex',
        jobTitles: ['Book Clerk', 'Book Shelver', 'Café Worker', 'Cleanup Crew Member', 'Garden Tender', 'Store Worker'],
        coworkers: ['Drazhomir Yarnask'],
    },
    {
        employer: "Bow's End Tavern",
        jobTitles: ['Assistant Manager', 'Cleanup Crew Member', 'Cook', 'Host', 'Server'],
        coworkers: ['Javenesh Stoutclaw'],
    },
    {
        employer: 'Campus Grounds',
        jobTitles: [
            'Graffiti Eraser',
            'Lawn Manicurist',
            'Litter Retriever',
            'Sidewalk Sweeper',
            'Statuary Repairer',
            'Trash Collector',
        ],
        coworkers: ['Shuvadri Glintmantle'],
    },
    {
        employer: 'Campus Magic Labs',
        jobTitles: ['Cleanup Crew Member', 'Specimen Preparer', 'Volunteer Lab Partner'],
        coworkers: ['Urzmaktok Grojsh'],
    },
    {
        employer: 'Dormitories',
        jobTitles: ['Cleanup Crew Member', 'Events Assistant', 'Front-Desk Worker', 'Resident Assistant'],
        coworkers: ['Nora Ann Wu'],
    },
    {
        employer: 'Firejolt Café',
        jobTitles: ['Barista', 'Cashier', 'Cleanup Crew Member', 'Server'],
        coworkers: ['Mina Lee'],
    },
    {
        employer: 'Intramural Fields',
        jobTitles: ['Cleanup Crew Member', 'Crowd Manager', 'Equipment Assistant', 'Groundskeeper', 'Referee'],
        coworkers: ['Rosimyffenbip “Rosie” Wuzfeddlims'],
    },
    {
        employer: 'Strixhaven Performing Arts Society',
        jobTitles: [
            'Cleanup Crew Member',
            'General Assistant',
            'Refreshments Expert',
            'Stagehand',
            'Ticket Taker',
            'Usher',
        ],
        coworkers: ['Larine Arneza'],
    },
    {
        employer: 'Strixhaven Stadium',
        jobTitles: [
            'Cleanup Crew Member',
            'Entertainment Assistant',
            'Equipment Assistant',
            'Groundskeeper',
            'Refreshments Expert',
            'Ticket Taker',
            'Usher',
        ],
        coworkers: ['Aurora Luna Wynterstarr', 'Greta Gorunn'],
    },
];
